import types from './types.js'

const state = {
  loading: false,
  show: false,
  title: '',
  text: '',
  warningMessage: false,
  cta: '',
  action: null,
  cancelAction: null
}

const mutations = {
  [types.SHOW_CONFIRM_DIALOG](state) {
    state = Object.assign(state, { show: true })
  },
  [types.HIDE_CONFIRM_DIALOG](state) {
    state = Object.assign(state, { show: false })
  },
  [types.SET_CONFIRM_DIALOG_OPTIONS](state, options) {
    state = Object.assign(state, options)
  }
}

export default {
  state,
  mutations
}
